import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Box } from "../Box";
import { Slider } from "../Slider";
import { theme } from "../../theme";
import { textStyles } from "../Text";
import { useForkedRef } from "../../hooks";
import { useRegisterMenuItem } from "./useRegisterMenuItem";
/**
 * MenuSlider
 *
 * A Slider for use within a Menu.
 */

export var MenuSlider = React.forwardRef(function (_ref, forwardedRef) {
  var label = _ref.label,
      value = _ref.value,
      disabled = _ref.disabled,
      other = _objectWithoutProperties(_ref, ["label", "value", "disabled"]);

  var ownRef = useRef(null);
  var ref = useForkedRef(forwardedRef, ownRef);

  var _useRegisterMenuItem = useRegisterMenuItem(ownRef),
      isSelected = _useRegisterMenuItem.isSelected;

  var sliderRef = useRef(null);
  useEffect(function () {
    if (isSelected) {
      sliderRef.current.focus();
    }
  }, [isSelected]);
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(MenuSliderContainer, {
    ref: ref,
    disabled: disabled,
    $hasMarks: !!other.marks
  }, /*#__PURE__*/React.createElement(Box, {
    paddingX: 8,
    width: "100%"
  }, /*#__PURE__*/React.createElement(Slider, _extends({
    showTooltip: false,
    showHoverIndicator: false,
    ref: sliderRef,
    value: value,
    disabled: disabled
  }, other))), label && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    width: 12
  }), /*#__PURE__*/React.createElement(Label, null, typeof label === 'function' ? label(value) : value))));
});
var Container = styled.div.withConfig({
  displayName: "MenuSlider__Container",
  componentId: "vapor__sc-9nl86u-0"
})(["padding:", " ", ";"], theme.spaces[2], theme.spaces[8]);
var Label = styled.div.withConfig({
  displayName: "MenuSlider__Label",
  componentId: "vapor__sc-9nl86u-1"
})(["height:", ";min-width:42px;border:1px solid ", ";border-radius:", ";", ";color:", ";display:flex;align-items:center;justify-content:center;font-variant-numeric:tabular-nums;user-select:none;"], theme.spaces[24], theme.colors.border.primary, theme.radii[4], textStyles.secondary, theme.colors.text.tertiary);
var MenuSliderContainer = styled.div.withConfig({
  displayName: "MenuSlider__MenuSliderContainer",
  componentId: "vapor__sc-9nl86u-2"
})(["width:100%;height:", ";display:flex;align-items:center;padding:", " 0;&[disabled]{pointer-events:none;}"], function (p) {
  return p.$hasMarks ? theme.spaces[48] : theme.spaces[32];
}, theme.spaces[4]);